// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  regionId: __t.u64().primaryKey().name("region_id"),
  worldId: __t.u64().name("world_id"),
  regionX: __t.i32().name("region_x"),
  regionZ: __t.i32().name("region_z"),
  biome: __t.string(),
  noBuild: __t.bool().name("no_build"),
  heightmapRef: __t.string().name("heightmap_ref"),
});
